import React from "react";
import { Route } from "react-router-dom"
import ChangePassword from "./views/change-password/ChangePassword"

export default [
  <Route exact path="/change-password" component={ChangePassword} />
];
